// // hooks/useAppOpenAd.ts
// import { useEffect, useRef, useCallback } from 'react';
// import { AppState, Platform } from 'react-native';
// import { AppOpenAd, AdEventType, TestIds } from 'react-native-google-mobile-ads';
// import { androidAppOpenADKey, iosAppOpenADKey } from './contants';

// const adUnitId = Platform.OS === 'ios'
//   ? iosAppOpenADKey
//   : androidAppOpenADKey;

// export const useAppOpenAd = () => {
//   const appOpenAdRef = useRef<AppOpenAd | null>(null);
//   const isLoadedRef = useRef(false);
//   const isShowingRef = useRef(false);
//   const hasShownOnColdStartRef = useRef(false);

//   const loadAd = useCallback(() => {
//     if (isShowingRef.current) return;

//     const appOpenAd = AppOpenAd.createForAdRequest(adUnitId, {
//       keywords: ['ludo', 'game'],
//     });

//     appOpenAdRef.current = appOpenAd;

//     const unsubscribeLoaded = appOpenAd.addAdEventListener(AdEventType.LOADED, () => {
//       console.log('✅ App Open Ad Loaded Successfully');
//       isLoadedRef.current = true;
//     });

//     const unsubscribeClosed = appOpenAd.addAdEventListener(AdEventType.CLOSED, () => {
//       console.log('App Open Ad Closed');
//       isShowingRef.current = false;
//       isLoadedRef.current = false;
//       hasShownOnColdStartRef.current = true;
//       loadAd(); // Preload next ad
//     });

//     const unsubscribeError = appOpenAd.addAdEventListener(AdEventType.ERROR, (err) => {
//       console.log('App Open Ad Error:', err);
//       isLoadedRef.current = false;
//     });

//     appOpenAd.load();

//     return () => {
//       unsubscribeLoaded();
//       unsubscribeClosed();
//       unsubscribeError();
//     };
//   }, []);

//   const showAdIfAvailable = useCallback(async (): Promise<boolean> => {
//     if (!appOpenAdRef.current || !isLoadedRef.current || isShowingRef.current) {
//       console.log('Ad not ready to show');
//       return false;
//     }

//     try {
//       isShowingRef.current = true;
//       await appOpenAdRef.current.show();
//       console.log('✅ App Open Ad Shown');
//       return true;
//     } catch (error) {
//       console.error('Failed to show ad:', error);
//       isShowingRef.current = false;
//       return false;
//     }
//   }, []);

//   // Load ad as soon as possible
//   useEffect(() => {
//     loadAd();
//   }, [loadAd]);

//   // Handle foreground (background → foreground)
//   useEffect(() => {
//     const subscription = AppState.addEventListener('change', (nextState) => {
//       if (nextState === 'active' && !isShowingRef.current) {
//         setTimeout(() => {
//           showAdIfAvailable();
//         }, 600);
//       }
//     });

//     return () => subscription.remove();
//   }, [showAdIfAvailable]);

//  return {
//   showAdIfAvailable,
//   loadAd,
//   hasShownOnColdStart: hasShownOnColdStartRef
// };
// };

import { useEffect } from "react";
import { AppState, Platform } from "react-native";
import {
  AppOpenAd,
  AdEventType,
  TestIds,
} from "react-native-google-mobile-ads";
import { androidAppOpenADKey, iosAppOpenADKey } from "./contants";

const adUnitId = Platform.OS === "ios" ? iosAppOpenADKey : androidAppOpenADKey;

const appOpenAd = AppOpenAd.createForAdRequest(adUnitId);

// You can use this function to manually pause the ad before asking for permissions or opening a popup.
// Example: setAppOpenAdPaused(true); await requestPermission(); setAppOpenAdPaused(false);
export let isAppOpenAdPaused = false;
let pauseTimeout: ReturnType<typeof setTimeout>;

export const setAppOpenAdPaused = (paused: boolean, delay: number = 0) => {
  if (pauseTimeout) clearTimeout(pauseTimeout);
  
  if (delay > 0) {
    pauseTimeout = setTimeout(() => {
      isAppOpenAdPaused = paused;
    }, delay);
  } else {
    isAppOpenAdPaused = paused;
  }
};

export const useAppOpenAd = () => {
  useEffect(() => {
    let isLoaded = false;
    let wasInBackground = false;
    let backgroundTime = 0;

    const loadedListener = appOpenAd.addAdEventListener(
      AdEventType.LOADED,
      () => {
        isLoaded = true;
      },
    );

    const closedListener = appOpenAd.addAdEventListener(
      AdEventType.CLOSED,
      () => {
        isLoaded = false;
        appOpenAd.load();
      },
    );

    appOpenAd.load();

    const appStateListener = AppState.addEventListener(
      "change",
      (nextState) => {
        if (nextState === "background") {
          wasInBackground = true;
        }

        if (nextState === "active") {
          if (wasInBackground && isLoaded && !isAppOpenAdPaused) {
            appOpenAd.show();
          }
          wasInBackground = false;
        }
      },
    );

    return () => {
      loadedListener();
      closedListener();
      appStateListener.remove();
    };
  }, []);
};
